module.exports = __webpack_public_path__ + "c66063d06606f28644bc029362655043.svg";